export const GradientCollection = [
  "radial-gradient(at left top, #11B13D, #D2D9CD)",
  "radial-gradient(at left top, #8D347D, #C6B24E)",
  "radial-gradient(at left top, #5CE3A1, #EE21AF)",
  "radial-gradient(at left top, #48D192, #EB5ACD)",
  "radial-gradient(at left top, #4EE9E2, #D6C7A3)",
  "linear-gradient(225deg, #1A9B4E, #C755E9)",
  "linear-gradient(225deg, #8910B4, #6CC87F)",
  "linear-gradient(225deg, #1996C5, #FCEE2B)",
];
